(() => {
  const exactTranslations = new Map([
    ['Terms and Policies', 'Kushtet dhe politikat'],
    ['Account', 'Llogaria'],
    ['Orders', 'Porositë'],
    ['Profile', 'Profili'],
    ['Your cart is empty', 'Shporta juaj është bosh'],
    ['Continue shopping', 'Vazhdo blerjet'],
    ['Log in', 'Hyr'],
    ['Sold out', 'E shitur'],
    ['Add', 'Shto'],
    ['Size', 'Madhësia'],
    ['Shoe size', 'Madhësia e këpucëve']
  ]);

  const replaceMarketNames = (value) => value
    .replaceAll('Maqedoni të Veriut', 'Maqedoni')
    .replaceAll('Maqedonia e Veriut', 'Maqedoni');

  const translateTextNode = (node) => {
    const original = node.nodeValue;
    if (!original || !original.trim()) return;
    let updated = replaceMarketNames(original);
    const trimmed = updated.trim();
    if (node.parentElement?.closest('.ar-trust') && trimmed === 'Dërgim 1–2 ditë') {
      updated = updated.replace(trimmed, 'Dërgim i shpejtë');
    } else if (exactTranslations.has(trimmed)) {
      updated = updated.replace(trimmed, exactTranslations.get(trimmed));
    }
    if (updated !== original) node.nodeValue = updated;
  };

  const translateElement = (element) => {
    if (!(element instanceof Element)) return;
    ['aria-label', 'title', 'placeholder'].forEach((attribute) => {
      const original = element.getAttribute(attribute);
      if (!original) return;
      let updated = replaceMarketNames(original);
      if (exactTranslations.has(updated.trim())) updated = exactTranslations.get(updated.trim());
      if (updated !== original) element.setAttribute(attribute, updated);
    });
  };

  const translateRoot = (root) => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      translateTextNode(root);
      return;
    }
    translateElement(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === Node.TEXT_NODE) {
        const parent = node.parentElement;
        if (parent && !['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'].includes(parent.tagName)) translateTextNode(node);
      } else {
        translateElement(node);
      }
    }
  };

  const run = () => translateRoot(document.body);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) mutation.addedNodes.forEach(translateRoot);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
